import React from "react"
import classes from "./Checkbox.module.scss"

interface ICheckboxProps {
  name: string
  text?: string
  className?: string
  valid?: boolean
  shouldValidate?: boolean
  onChange?: any
  checked: boolean
  disabled?: boolean
}

function Checkbox({text, className, valid, shouldValidate, disabled, ...rest}: ICheckboxProps) {

  const cls = [classes.wrap]

  if (className) {
    cls.push(className)
  }

  if (disabled) {
    cls.push(classes.disabled)
  }

  if (!valid && shouldValidate)
    cls.push(classes.error)

  const textTemplate = text && <span className={classes.text}>{text}</span>

  return (
    <div className={cls.join(" ")}>
      <label>
        <input
          type="checkbox"
          disabled={disabled}
          {...rest}
        />
        <span className={classes.cr}></span>
        {textTemplate}
      </label>
    </div>
  )
}

export default Checkbox